import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import ComparisonSection from './components/ComparisonSection';
import CTASplitSection from './components/CTASplitSection';
import BlogPreview from './components/BlogPreview';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureSection />
        <ComparisonSection />
        <CTASplitSection />
        <BlogPreview />
        <Testimonials />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}